/* import __COLOCATED_TEMPLATE__ from './undo-send-delay-submenu.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    item: {
      text: string;
      currentLabel: string;
      subGroupList: unknown[];
      onSelectSubItem: (item: unknown) => void;
    };
  };
}

const UndoSendDelaySubmenu = templateOnlyComponent<Signature>();
export default UndoSendDelaySubmenu;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::UndoSendDelaySubmenu': typeof UndoSendDelaySubmenu;
    'inbox2/composer/undo-send-delay-submenu': typeof UndoSendDelaySubmenu;
  }
}
